import { useVehicleForm } from "./hooks/useVehicleForm";
import { FormSections } from "./sections/FormSections";
import { VehicleDetails } from "@/types/vehicleDetails";
import { useEffect, useRef } from "react";

interface VehicleDetailsFormProps {
  initialData?: Partial<VehicleDetails>;
  onChange: (details: Partial<VehicleDetails>) => void;
  onNext: () => void;
  isAutoLoaded?: boolean;
  showCondition?: boolean;
  onAutoLoadedFieldEditAttempt?: () => void;
  isManualMode?: boolean;
  regNumber?: string;
  onRegNumberChange?: (regNumber: string) => void;
}

export const VehicleDetailsForm = ({
  initialData = { equipment: [] },
  onChange,
  onNext,
  isAutoLoaded = false,
  showCondition = true,
  onAutoLoadedFieldEditAttempt,
  isManualMode = false,
  regNumber = "",
  onRegNumberChange,
}: VehicleDetailsFormProps) => {
  const prevInitialDataRef = useRef(initialData);

  useEffect(() => {
    const hasChanged =
      prevInitialDataRef.current.make !== initialData.make ||
      prevInitialDataRef.current.model !== initialData.model ||
      prevInitialDataRef.current.year !== initialData.year ||
      prevInitialDataRef.current.fuelType !== initialData.fuelType ||
      prevInitialDataRef.current.bodyType !== initialData.bodyType ||
      prevInitialDataRef.current.color !== initialData.color ||
      prevInitialDataRef.current.transmission !== initialData.transmission ||
      prevInitialDataRef.current.variant !== initialData.variant;

    if (hasChanged) {
      // DEBUG: Uncomment for debugging initialData changes
      // console.log('[VehicleDetailsForm] 🔄 initialData changed:', {
      //   prev: {
      //     make: prevInitialDataRef.current.make,
      //     model: prevInitialDataRef.current.model,
      //     year: prevInitialDataRef.current.year,
      //     fuelType: prevInitialDataRef.current.fuelType,
      //     bodyType: prevInitialDataRef.current.bodyType,
      //     color: prevInitialDataRef.current.color,
      //     transmission: prevInitialDataRef.current.transmission,
      //     variant: prevInitialDataRef.current.variant,
      //   },
      //   new: {
      //     make: initialData.make,
      //     model: initialData.model,
      //     year: initialData.year,
      //     fuelType: initialData.fuelType,
      //     bodyType: initialData.bodyType,
      //     color: initialData.color,
      //     transmission: initialData.transmission,
      //     variant: initialData.variant,
      //   },
      //   isAutoLoaded,
      // });
      prevInitialDataRef.current = initialData;
    }
  }, [initialData, isAutoLoaded]);

  const {
    vehicleDetails,
    openSections,
    handleSelectChange,
    handleEditSection,
    handleNext,
  } = useVehicleForm(
    initialData,
    onChange,
    isAutoLoaded,
    onAutoLoadedFieldEditAttempt,
    isManualMode,
    regNumber
  );

  useEffect(() => {
    // DEBUG: Uncomment for debugging vehicleDetails state
    // console.log('[VehicleDetailsForm] 📊 Current vehicleDetails state:', {
    //   make: vehicleDetails.make,
    //   model: vehicleDetails.model,
    //   year: vehicleDetails.year,
    //   fuelType: vehicleDetails.fuelType,
    //   bodyType: vehicleDetails.bodyType,
    //   color: vehicleDetails.color,
    //   transmission: vehicleDetails.transmission,
    //   variant: vehicleDetails.variant,
    //   engineVolume: vehicleDetails.engineVolume,
    //   isAutoLoaded,
    // });
  }, [vehicleDetails, isAutoLoaded]);

  return (
    <div className="space-y-4 mb-4 w-full max-w-xl mx-auto">
      <FormSections
        vehicleDetails={vehicleDetails}
        openSections={openSections}
        handleSelectChange={handleSelectChange}
        handleEditSection={handleEditSection}
        handleNext={handleNext}
        onNext={onNext}
        showCondition={showCondition}
        isAutoLoaded={isAutoLoaded}
        onAutoLoadedFieldEditAttempt={onAutoLoadedFieldEditAttempt}
        isManualMode={isManualMode}
        regNumber={regNumber}
        onRegNumberChange={onRegNumberChange}
      />
    </div>
  );
};
